import { render, staticRenderFns } from "./DescricaoInput.vue?vue&type=template&id=39525472"
import script from "./DescricaoInput.vue?vue&type=script&lang=js"
export * from "./DescricaoInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports